<div
  class="cx-modal-container"
  [cxFocus]="focusConfig"
  (esc)="dismissModal('Escape pressed')"
  >
  <div class="cx-modal-content">
    <!-- Modal Header -->
    @if (loaded$ | async) {
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          {{ (title | cxTranslate) }}
        </div>
        <button
          type="button"
          class="close"
          attr.aria-label="{{ 'addToCart.closeModal' | cxTranslate }}"
          (click)="dismissModal('Cross click')"
          >
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>
      <!-- Modal Body -->
      @if (entry$ | async; as entry) {
        <div class="cx-dialog-body modal-body">
          <div class="cx-dialog-row added-to-cart-dialog__row row">
            <div class="cx-dialog-item col-sm-12 col-md-6">
              <app-uig-cart-item [item]="entry"
                [compact]="true"
                [quantityControl]="getQuantityControl() | async"
                [promotionLocation]="promotionLocation"
                [showNotes]="false"
                [hideDeleteButton]="true"
                [hideBulkyGoods]="false">
              </app-uig-cart-item>
            </div>
            <!-- Separator -->
            <div
                  class="
              cx-dialog-separator
              col-sm-12
              d-xs-block d-sm-block d-md-none
            "
            ></div>
            <!-- Total container -->
            @if (cart$ | async; as cart) {
              <div
                class="cx-dialog-actions col-sm-12 col-md-6"
                >
                <div class="cx-dialog-total added-to-cart-dialog__total row no-gutters">
                  <div class="col-8">{{ 'cartItems.cartTotal' | cxTranslate: { count: cart.deliveryItemsQuantity } }}</div>
                  <div class="col-4 text-right">{{ cart.subTotal?.formattedValue }}</div>
                </div>
                <!-- Promotions -->
                <div class="cx-dialog-promotions">
                  <cx-promotions
                      [promotions]="
                  (cart.appliedOrderPromotions || []).concat(
                    cart.potentialOrderPromotions || []
                  )
                "
                  ></cx-promotions>
                </div>
                <!-- Actions -->
                <div class="cx-dialog-buttons">
                  <a
                    [class.disabled]="form.dirty"
                    [routerLink]="{ cxRoute: 'cart' } | cxUrl"
                    cxModal="dismiss"
                    cxModalReason="View Cart click"
                    class="btn btn-secondary added-to-cart-dialog__view-cart"
                    autofocus
                    >{{ 'addToCartLayer.goToCart' | cxTranslate }}</a
                    >
                    <div class="col-md-3 cx-remove-btn">
                      <button class="link cx-action-link"
                        [disabled]="(getQuantityControl() | async).disabled"
                        (click)="removeItem()"
                        attr.aria-label="{{ 'addToCart.removeFromCart' | cxTranslate }}">
                        {{ "addToCartLayer.removeItem" | cxTranslate }}
                      </button>
                    </div>
                  </div>
                </div>
              }
            </div>
            <div class="cx-dialog-row notes-row">
              <app-uig-cart-notes
                [cartItem]="entry"
                [cartId]="(cart$ | async).code">
              </app-uig-cart-notes>
            </div>
          </div>
        }
      } @else {
        <div class="cx-dialog-header modal-header">
          <div class="cx-dialog-title modal-title">
            {{ 'addToCart.updatingCart' | cxTranslate }}
          </div>
          <button
            type="button"
            class="close"
            [attr.aria-label]="'common.close' | cxTranslate"
            (click)="dismissModal('Cross click')"
            >
            <span aria-hidden="true">
              <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
            </span>
          </button>
        </div>
        <!-- Modal Body -->
        <div class="cx-dialog-body modal-body">
          <div class="cx-dialog-row">
            <div class="col-sm-12"><cx-spinner></cx-spinner></div>
          </div>
        </div>
      }


    </div>
  </div>
